/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import React from 'react';

import { FormattedMessage } from 'react-intl';

// Messages
import messages from './messages/LoginDisclaimer_messages';

// Styles
import './styles/LoginDisclaimer.scss';

const LoginDisclaimer = () => (
  <div styleName="LoginDisclaimer">
    <div className="main pure-g">
      <div className="pure-u-1-24" />
      <div className="pure-u-22-24">
        <div className="container text-center">
          <p>
            <FormattedMessage
              {...messages.loginDisclaimer}
              info="Explains why login is required"
            />
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default LoginDisclaimer;
